// import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import Swiper from 'react-id-swiper';
import Lightbox from 'react-image-lightbox';
import * as styles from 'styles/gallery.scss';
import 'styles/react-id-swiper.css';


class ReactIDSwiperGallery extends React.Component {
    targetHeight = 600;
    targetThumbnailHeight = 120;

    constructor(props) {
        super(props);
        this.state = {
            currentImage: 0,
            lightboxIsOpen: false,
            gallerySwiper: null,
            thumbnailSwiper: null,

            photoSet: props.photoset,
            width: 0,
            height: 0,
        }

        // this.width = this.width.bind(this);
        // this.thumbnailWidth = this.thumbnailWidth.bind(this);

        this.galleryRef = this.galleryRef.bind(this);
        this.thumbRef = this.thumbRef.bind(this);
        // this.smallRef = this.smallRef.bind(this);

        this.closeLightbox = this.closeLightbox.bind(this);
        this.openLightbox = this.openLightbox.bind(this);

        this.gotoNext = this.gotoNext.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    large() {
        return this.state.width >= styles.breakpoint;
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.gallerySwiper && nextState.thumbnailSwiper && !this.state.lightboxIsOpen) {
            const { gallerySwiper, thumbnailSwiper } = nextState;

            gallerySwiper.controller.control = thumbnailSwiper;
            thumbnailSwiper.controller.control = gallerySwiper;
        }
        if (!this.state.lightboxIsOpen && nextState.lightboxIsOpen) {
            // console.log(nextState.gallerySwiper);
            // if (nextState.gallerySwiper) {
            nextState.currentImage = nextState.gallerySwiper.activeIndex;
            // } else if (nextState.smallSwiper) {
            //     nextState.currentImage = nextState.smallSwiper.activeIndex;
            // }
        }
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    galleryRef(ref) {
        if (ref) this.setState({ gallerySwiper: ref.swiper })
    }

    thumbRef(ref) {
        if (ref) this.setState({ thumbnailSwiper: ref.swiper })
    }

    // smallRef(ref) {
    //     if (ref) this.setState({ smallSwiper: ref.swiper })
    // }
    // galleryRef(ref) {
    //     if (ref) this.setState({ gallerySwiper: ref.swiper, swiper: ref.swiper })
    // }

    // thumbRef(ref) {
    //     if (ref) this.setState({ thumbnailSwiper: ref.swiper, swiper: ref.swiper })
    // }

    // galleryRef = ref => {
    //     if (ref) this.setState({ gallerySwiper: ref.swiper });
    // };
    
    // thumbRef = ref => {
    //     if (ref) this.setState({ thumbnailSwiper: ref.swiper });
    // };

    // width(width, height) {
    //     return this.targetHeight * width / height;
    // }

    gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }
    gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }

    // thumbnailWidth(width, height) {
    //     return this.targetThumbnailHeight * width / height;
    // }

    openLightbox() {
        this.setState({
            lightboxIsOpen: true,
        });
    }
    closeLightbox() {
        this.setState({
            lightboxIsOpen: false,
        });
    }

    setActiveIndex(large) {
        this.setState({ currentImage: large ? 
            this.state.gallerySwiper.activeIndex :
            this.state.smallSwiper.activeIndex
        });
    }

    render() {
        const gallerySwiperParams = {
            // effect: 'coverflow',
            //grabCursor: true,
            // slidesPerView: 'auto',
            //centeredSlides: true,
            //loop: true,
            // coverflowEffect: {
            //     rotate: 50,
            //     stretch: 0,
            //     depth: 100,
            //     modifier: 1,
            //     slideShadows: true,
            // },
            // pagination: {
            //   el: '.swiper-pagination',
            //   renderBullet: (index, className) => {
            //     return '<span class="' + className + '">' + (index + 1) + '</span>';
            //   },
            //   clickable: true
            // },
            centeredSlides: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            initialSlide: this.state.currentImage,
            on: {
                slideChangeTransitionEnd:
                    () => this.state.gallerySwiper && this.setActiveIndex(true),
            },
            spaceBetween: 100,
            keyboard: true,
            shouldSwiperUpdate: true,
        };

        const smallSwiperParams = {
            centeredSlides: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            initialSlide: this.state.currentImage,
            on: {
                slideChangeTransitionEnd:
                    () => this.state.smallSwiper && this.setActiveIndex(false),
            },
            spaceBetween: 100,
            keyboard: true,
            shouldSwiperUpdate: true,
        };

        const thumbnailSwiperParams = {
            spaceBetween: 0,
            centeredSlides: true,
            slidesPerView: 15,
            touchRatio: 0.2,
            slideToClickedSlide: true,
            initialSlide: this.state.currentImage,
            on: {
                slideChangeTransitionEnd:
                    () => this.state.gallerySwiper && this.setActiveIndex(true),
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                hide: false,
            },
            fadeEffect: {
                crossFade: true
            },
            shouldSwiperUpdate: true,
        };

        let swiper = (
            <Swiper {...gallerySwiperParams} ref={this.galleryRef}>
                {this.props.photoset.map(item =>
                    <div key={'swiper' + item.src} className='swiper-gallery'>
                        <img className='image'
                            src={item.src}
                            alt={item.caption}
                            title={item.caption}
                            //width={'80%'}//{this.width(item.width, item.height)}
                            //height={'80%'}//{this.targetHeight}
                            onClick={this.openLightbox}
                        />
                    </div>
                )}
            </Swiper>
        );

        let thumbnailSwiper = (
            <Swiper {...thumbnailSwiperParams} ref={this.thumbRef}>
                {this.props.photoset.map(item =>
                    <div key={'thumbnail' + item.src} className='thumbnail-gallery'>
                        <img className='thumbnail'
                            src={item.thumbnail}
                            alt={item.caption}
                            title={item.caption}
                            width={item.thumbnailWidth}
                            height={item.thumbnailHeight}
                        />
                    </div>
                )}
            </Swiper>
        );

        // let smallSwiper = (
        //     <Swiper {...smallSwiperParams} ref={this.smallRef}>
        //         {this.props.photoset.map(item =>
        //             <div key={'small' + item.src} className='small-gallery'>
        //                 <img className='image'
        //                     src={item.src}
        //                     alt={item.caption}
        //                     title={item.caption}
        //                     //width={'80%'}//{this.width(item.width, item.height)}
        //                     //height={'80%'}//{this.targetHeight}
        //                     onClick={this.openLightbox}
        //                 />
        //             </div>
        //         )}
        //     </Swiper>
        // )

        const lightbox = this.state.currentImage && <Lightbox
            images={this.props.photoset}
            imageTitle={<div>{this.props.photoset[this.state.currentImage].title}</div>}
            imageCaption={<div>{this.props.photoset[this.state.currentImage].caption.split('<p />').map(c => <div key={c}>{c}<p /></div>)}</div>}
            onCloseRequest={this.closeLightbox}
            onMovePrevRequest={this.gotoPrevious}
            onMoveNextRequest={this.gotoNext}
            mainSrc={this.props.photoset[this.state.currentImage].src}
            prevSrc={this.state.currentImage === 0 ? null : this.props.photoset[this.state.currentImage - 1].src}
            nextSrc={this.state.currentImage === this.props.photoset.length - 1 ?
                null : this.props.photoset[this.state.currentImage + 1].src}
            isOpen={this.state.lightboxIsOpen}
            reactModalStyle={{
                content: {
                    zIndex: 10000,
                }
            }}
        />;

        return (
            // this.large() ?
            <div className='id-swiper-gallery'>
                {!this.state.lightboxIsOpen && swiper}
                {!this.state.lightboxIsOpen && thumbnailSwiper}
                {this.state.lightboxIsOpen && lightbox}
            </div> 
            //: <div className='id-swiper-gallery'>
            //     {!this.state.lightboxIsOpen && smallSwiper}
            //     {this.state.lightboxIsOpen && lightbox}
            // </div>
            // <div className='id-swiper-gallery'>
            //     {!this.state.lightboxIsOpen && smallSwiper}
            //     {this.state.lightboxIsOpen && lightbox}
            // </div>
        );
    }
}

export default ReactIDSwiperGallery;



// WEBPACK FOOTER //
// ./src/components/GalleryPage/ReactIDSwiperGallery.js